<template>
  <div>
    <NotificationModal
      ref="modal"
      v-model="bindsForModal.isModalOpen"
      :modal="bindsForModal.isModalOpen"
      v-bind="bindsForModal"
    />

    <DeleteGenreModal
      v-model="isConfirmationDeleteModalOpen"
      :modal="isConfirmationDeleteModalOpen"
      :onClose="handleCloseConfirmationDeleleteModal"
      :onSubmitManually="handleSubmitDelete"
      :itemToDelete="selectedItem"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import {
  SET_OVERFLOW,
  SET_EDIT_FORM,
} from '../../store/actions/common';
import {
  GET_GENRE_IN_USE_STATUS_REQUEST,
  DELETE_GENRE_REQUEST,
} from '../../store/actions/genres/genresActions';
import NotificationModal from '../../components/NotificationModal.vue';
import DeleteGenreModal from './DeleteGenreModal.vue';
import CONFIG from '../../constants/config';

export default {
  name: 'DeleteGenreInTwoSteps',
  components: {
    NotificationModal,
    DeleteGenreModal,
  },
  data() {
    return {
      isConfirmationDeleteModalOpen: false,
      selectedItem: null,
      bindsForModal: {
        isModalOpen: false,
        title: '',
        bodyMessage: '',
        isInUseAsset: false,
        warningMess: '',
        onAccept: () => {},
        onClose: () => {},
      },
    };
  },
  computed: {
    ...mapState({
      // genre: (state) => state.genres.genre,
    }),
    ...mapGetters([
      'getCurrentAccountId',
    ]),
  },
  methods: {
    handleOpenModalForRemove(item) {
      this.selectedItem = item;
      const paramsToGetStatus = {
        accountId: this.getCurrentAccountId,
        id: this.selectedItem.id,
      };

      this.$store.dispatch(GET_GENRE_IN_USE_STATUS_REQUEST, paramsToGetStatus)
        .then(this.processOpenModalForRemove);
    },
    processOpenModalForRemove(response) {
      const { isInUse } = response;
      const {
        deleteGenreTitle,
        deleteGenreConfirmationMessage,
        genreInUseWarningMessage,
      } = CONFIG.modals;

      if (!isInUse) {
        this.bindsForModal.title = deleteGenreTitle;
        this.bindsForModal.bodyMessage = deleteGenreConfirmationMessage;
        this.bindsForModal.onAccept = this.removeGenre;
        this.bindsForModal.onClose = this.handleCloseModal;
      } else {
        this.bindsForModal.title = deleteGenreTitle;
        this.bindsForModal.bodyMessage = deleteGenreConfirmationMessage;
        this.bindsForModal.isInUseAsset = true;
        this.bindsForModal.warningMess = genreInUseWarningMessage;
        this.bindsForModal.onAccept = this.handleOpenConfirmationDeleleteModal;
        this.bindsForModal.onClose = this.handleCloseModal;
      }

      this.$store.dispatch(SET_OVERFLOW, true);
      this.bindsForModal.isModalOpen = true;
    },
    removeGenre() {
      const params = {
        accountId: this.getCurrentAccountId,
        genreId: this.selectedItem.id,
      };

      this.$store.dispatch(DELETE_GENRE_REQUEST, params)
        .then(() => {
          this.$toasted.global.success({
            message: 'The Genre has been successfully deleted',
          });
          this.$emit('runAfterComplete');
        })
        .catch(() => {
          this.$toasted.global.error({
            message: 'The Genre has not been deleted',
          });
        });
    },
    handleOpenConfirmationDeleleteModal() {
      this.isConfirmationDeleteModalOpen = true;
    },
    handleCloseConfirmationDeleleteModal() {
      this.isConfirmationDeleteModalOpen = false;
      this.handleCloseModal();
    },
    handleSubmitDelete() {
      this.isConfirmationDeleteModalOpen = false;
      this.handleCloseModal();
      this.$emit('runAfterComplete');
    },
    handleCloseModal() {
      this.bindsForModal.isModalOpen = false;
      this.$store.dispatch(SET_OVERFLOW, false);
      this.$store.dispatch(SET_EDIT_FORM, false);
    },
  },
};
</script>
